// extracted by mini-css-extract-plugin
export default {"custom-styled-label":"custom-styled-label_EN_PyS6X"};